<template>
  <div class="page-wrapper">
    <commonHeader heading="学习力数据管理" subtitle="学习力数据评估">
    </commonHeader>
    <div class="page-content">
      <v-card>
        <div id="studyPieChart"></div>
        <div class="target-btn">
          <v-btn color="#caf982" @click="toIndex()">

            指标管理
          </v-btn>
          <v-btn color="#80ffff" @click="toSurvey()">

            参与调研
          </v-btn>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import CommonHeader from '@/components/DataService/CommonHeader.vue';
import { mapGetters } from 'vuex';
export default {
  components: {
    CommonHeader
  },
  data() {
    return {
      queryParams: {
        name: '',
        name1: '',
        select: '',
      },
      studyPieChart: null


    };
  },
  computed: {
    ...mapGetters(['isMobile']),
  },
  watch: {
    'isMobile.isMobile'(news) {
      if (!news) {
        setTimeout(() => {
          this.studyPieChart.dispose();
          this.getStudyPieChart();
        }, 500);
      }
    },
  },
  created() {

  },

  mounted() {
    this.getStudyPieChart()
  },

  methods: {
    getStudyPieChart() {
      this.studyPieChart = echarts.init(document.getElementById('studyPieChart'));
      var option;

      option = {
        tooltip: {
          trigger: 'item'
        },

        legend: {
          bottom: '0%',
          left: 'center'
        },
        series: [
          {
            name: 'Access From',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2
            },
            // 是否显示箭头指引
            label: {
              show: true,
              // position: 'center'
            },
            emphasis: {
              // label: {
              //   show: true,
              //   fontSize: 40,
              //   fontWeight: 'bold'
              // },
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            labelLine: {
              show: true
            },
            data: [
              { value: 330, name: '自我驱动力' },
              { value: 735, name: '信息获取力' },
              { value: 600, name: '知识转化力' },
              { value: 263, name: '持续学习力' },
            ]
          }
        ]
      };

      
      this.studyPieChart.setOption(option);

      // 根据页面大小自动响应图表大小
      let _this = this;
      window.addEventListener('resize', function () {
        _this.studyPieChart.resize();
      });

    },
    toIndex() {
      this.$router.push({
        name: 'LearningAbilityIndex',
      });
    },
    toSurvey() {
      this.$router.push({
        name: 'LearningAbilitySurvey',
      });
    },
  }
}
</script>

<style scoped>
.page-wrapper {
  margin: 0 15px;

  .page-content {
    text-align: center;

    #studyPieChart {
      width: 100%;
      height: 500px;
    }

    .target-btn {
      .v-btn {
        margin: 30px;
      }

      margin-top: 10px;
    }
  }
}
</style>